import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-height: 100vh;
  overflow-x: hidden;
`;

export const SectionContainer = styled.div`
  width: 90%;
  max-width: 1400px;
  margin: 0 auto;
`;
